export const isPhone = ['Android', 'iPhone'].some((v) => navigator.userAgent.includes(v));

export const mixin = (Vue) => {
    Vue.mixin({
        data() {
            return {
                pageData: {
                    isPhone,
                    title: process.env.projectConfig.title,
                    bizAccountId: 'NodeJs',
                    operator: 'NodeJs',
                },
            };
        },
        methods: {
            __getBizAccount(options) {
                return this.$hPost('/api/vss/shepherd/account/getBizAccountInfo', {}, { cache: true, ...options });
            },
            __querySupplierInfoByBizAccountId(options = {}) {
                // 通过账号获取供应商信息
                /**
                 * @bizAccountId
                 * 客户ID（登陆账号的ID）
                 *
                 * @customerId
                 * 供应商ID
                 *
                 * @supplierCode @code
                 * 供货规则code
                 *
                 * @supplierId
                 * 供货规则ID 即代表供货规则。
                 */
                return this.$hPost('/api/vss/second/shepherd/supplier/query/bizAccountId/supplier-info', {}, { cache: true, ...options });
            },
            __getSupplierInfoByBizAcountId() {
                // 通过账号获取供应商信息
                return this.$hPost('/api/vss/second/shepherd/supplier/get/bizAccountId/supplier-info', {}, { cache: true });
            },
            __logout() {
                let logoutUrl = 'noMatch';
                const nodeEnv = process.env.NODE_ENV;
                if (nodeEnv === 'production') {
                    logoutUrl = '/api/carrier/epassport/logout609';
                } else if (nodeEnv === 'staging') {
                    logoutUrl = '/api/carrier/epassport/logout367';
                } else {
                    logoutUrl = '/api/carrier/epassport/logout855';
                }
                logoutUrl = `${logoutUrl}?redirect_uri=${encodeURIComponent('/login.html')}`;
                window.location.href = `${window.location.origin}${logoutUrl}`;
            },
        },
    });
};
